import { Injectable } from '@angular/core';
import { collection, onSnapshot, query, Firestore } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { FirebaseService } from './firebase.service';
import { environment } from '../../environments/environment';
import { ReferenzaFirestore } from '../core/models/firestore/referenza.model';
import { normalizeReferenzaData } from '../core/utils/referenza.utils';

@Injectable({
  providedIn: 'root',
})
export class ReferenzeService {
  private firestore: Firestore;

  constructor(
    private firebaseService: FirebaseService,
    private logger: NGXLogger
  ) {
    this.firestore = this.firebaseService.firestore;
  }

  /**
   * Ritorna un Observable che emette sempre l'elenco corrente delle referenze
   * e rimane in ascolto sui cambiamenti della collection configurata negli environment.
   */
  listenReferenze(): Observable<ReferenzaFirestore[]> {
    return new Observable<ReferenzaFirestore[]>(observer => {
      try {
        const collectionName = environment.firebase.collectionReferenze;
        const collectionRef = collection(this.firestore, collectionName);
        const q = query(collectionRef);

        //this.logger.info('[REFERENZE-SERVICE] Inizio ascolto referenze da collection:', collectionName);

        const unsubscribe = onSnapshot(
          q,
          snapshot => {
            const referenze: ReferenzaFirestore[] = snapshot.docs.map(docSnap => {
              const data = docSnap.data() as ReferenzaFirestore;
              // Normalizza i dati (converte number -> string per codici)
              return normalizeReferenzaData(data);
            });

            this.logger.debug('[REFERENZE-SERVICE] Snapshot referenze ricevuto, numero elementi:', referenze.length);
            observer.next(referenze);
          },
          error => {
            this.logger.error('[REFERENZE-SERVICE] Errore durante l\'ascolto delle referenze:', error);
            observer.error(error);
          }
        );

        // Cleanup quando l'observable viene unsubscribed
        return () => {
          this.logger.info('[REFERENZE-SERVICE] Interrompo ascolto referenze');
          unsubscribe();
        };
      } catch (error) {
        this.logger.error('[REFERENZE-SERVICE] Errore inizializzazione ascolto referenze:', error);
        observer.error(error);
        return () => {};
      }
    });
  }
}


